import PropTypes from 'prop-types';

const pricingSchema = {
    maxUsd: PropTypes.number,
    minUsd: PropTypes.number,
};
const pricingShape = PropTypes.shape(pricingSchema);

const metricsSchema = {
    cities: PropTypes.number,
    countries: PropTypes.number,
    routes: PropTypes.number,
    stations: PropTypes.number,
    tripsPerDay: PropTypes.number,
    tripsPerMonth: PropTypes.number,
};
const metricsShape = PropTypes.shape(metricsSchema);

const quickviewSchema = {
    name: PropTypes.string.isRequired,
    type: PropTypes.any,
    value: PropTypes.number,
};

const quickviewShape = PropTypes.arrayOf(PropTypes.shape(quickviewSchema));

const statsSchema = {
    metrics: metricsShape.isRequired,
    pricing: pricingShape.isRequired,
};
const statsShape = PropTypes.shape(statsSchema);

const carrierGuideContentSchema = {
    carrierType: PropTypes.any, // ?? // modes
    primaryImageUrl: PropTypes.string,
};
const carrierGuideContentShape = PropTypes.shape(carrierGuideContentSchema);

const contactSchema = {};
const contactShape = PropTypes.object;

const currenciesSchema = {
    preferred: PropTypes.string,
    supported: PropTypes.arrayOf(PropTypes.string),
};
const currenciesShape = PropTypes.shape(currenciesSchema);

const vehiclesSchema = {
    primary: PropTypes.string,
    supported: PropTypes.arrayOf(PropTypes.string).isRequired,
};
const vehiclesShape = PropTypes.shape(vehiclesSchema);

const carrierSchema = {
    contact: contactShape.isRequired,
    currencies: currenciesShape.isRequired,
    features: PropTypes.arrayOf(PropTypes.string).isRequired,
    id: PropTypes.string,
    name: PropTypes.string,
    ticketTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    vehicleTypes: vehiclesShape.isRequired,
};
const carrierShape = PropTypes.shape(carrierSchema);

export {
    carrierGuideContentSchema,
    carrierGuideContentShape,
    carrierSchema,
    carrierShape,
    contactSchema,
    contactShape,
    currenciesSchema,
    currenciesShape,
    metricsSchema,
    metricsShape,
    pricingSchema,
    pricingShape,
    quickviewSchema,
    quickviewShape,
    statsSchema,
    statsShape,
    vehiclesSchema,
    vehiclesShape,
};

export default {
    pricingSchema,
    pricingShape,
    quickviewSchema,
    quickviewShape,
    metricsSchema,
    metricsShape,
    statsSchema,
    statsShape,
    carrierGuideContentSchema,
    carrierGuideContentShape,
    contactSchema,
    contactShape,
    currenciesSchema,
    currenciesShape,
    vehiclesSchema,
    vehiclesShape,
    carrierSchema,
    carrierShape,
};
